"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIntegerDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var isIntegerDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createIsInteger: _factoriesAny.createIsInteger
};
exports.isIntegerDependencies = isIntegerDependencies;